import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormContainer,
  Grid,
  Stack,
  TextField,
} from '@all-manager/design-system-v2';
import type { SpaceDatabase } from '../../types';
import useSpaceInfoCard from './useSpaceInfoCard';

type Props = {
  space: Pick<SpaceDatabase, 'id' | 'name'>;
  isAdmin: boolean;
};

export default function SpaceInfoCard(props: Props) {
  const hook = useSpaceInfoCard({ space: props.space });

  return (
    <Card>
      <CardHeader title="Informations générales" />
      <CardContent>
        <FormContainer onSubmit={hook.handleSubmit} noValidate>
          {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}
          <Grid container>
            <Grid size={{ xs: 12, md: 8, lg: 6 }}>
              <TextField
                label="Nom de la copropriété"
                value={hook.name}
                onChange={hook.handleNameChange}
                disabled={!props.isAdmin}
                required
                error={hook.isEmpty}
                helperText={hook.isEmpty ? 'Le nom est obligatoire' : undefined}
                fullWidth
              />
            </Grid>
          </Grid>
          {props.isAdmin ? (
            <Stack direction="row">
              <Button
                type="submit"
                variant="contained"
                size="small"
                loading={hook.isSaving}
                disabled={!hook.canSave}
              >
                Enregistrer
              </Button>
            </Stack>
          ) : null}
        </FormContainer>
      </CardContent>
    </Card>
  );
}
